export default __webpack_public_path__ + "static/media/premium.23cc6d3d.svg";